// Public Comeet careers-api embed constants — client-safe, static
// presentation values only. The token is server-sourced (config.comeet.apiKey) and
// passed in via initial props, so this client module never imports the server
// `configuration` (which pulls page_view_plugin / async_hooks).
export const COMEET_EMBED = {
    url: 'https://www.comeet.co/careers-api',
    fileName: 'api.js',
    companyName: 'Fiverr',
    color: '#1DBF73',
    fontSize: '16px',
} as const;
